import type { LinkProps } from '@tanstack/react-router';

import { forwardRef } from 'react';
import { Link } from '@tanstack/react-router';

// Router link component compatible with MUI Link
// Accept both `href` (MUI) and `to` (router style) — we forward whichever is set
// as TanStack Router's `to`. The lib doesn't know the consuming app's route
// tree, so we cast through to bypass TanStack's strict route-path typing.
export type RouterLinkProps = Omit<LinkProps, 'to'> & {
  to?: string;
  href?: string;
};

export const RouterLink = forwardRef<HTMLAnchorElement, RouterLinkProps>(
  ({ href, to, ...other }, ref) => {
    const linkTo = (href || to || '') as LinkProps['to'];
    return <Link ref={ref} to={linkTo} {...other} />;
  }
);

RouterLink.displayName = 'RouterLink';
